import { UserIcon } from '@components/icons/Icons';
import { Contain } from "@components/layout";
import useEnforceLoggedIn from '@hooks/useEnforceLoggedIn';
import { Routes } from "@lib/constants";
import { getWordpressVars } from '@lib/wordpressVars';
import { Button, Col, Row, Space } from "antd";
import { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";


const MainNav = () => {

    useEnforceLoggedIn();

    const location = useLocation();

    const [currentPage, setCurrentPage] = useState('');

    const { domain } = getWordpressVars();

    useEffect(() => {
        if (location.pathname) {
            setCurrentPage(location.pathname);
        }

    }, [location.pathname]);

    return (
        <div className={`pp-main-nav`}>
            <Contain>
                <Row
                    justify={`space-between`}
                    align={`middle`}
                >
                    <Col className={`branding`}>
                        <a href={`${domain}`} target='_blank' rel='noreferrer'>
                            <Space direction={`horizontal`}>
                                <span className={`logo-svg`}>
                                    <svg width="50" height="37" viewBox="0 0 50 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M40.8718 0H31.2117L29.7256 5.69558H40.8254C42.358 5.69558 43.5655 6.98785 43.5655 8.51944V22.7345C43.5655 24.3139 42.3115 25.5583 40.8254 25.5583H28.4716H24.3382L21.6445 36.8538L26.939 31.2539H40.8718C45.4232 31.2539 49.1386 27.4249 49.1386 22.7345V8.51944C49.1386 3.82896 45.4232 0 40.8718 0Z" fill="white" />
                                        <path d="M5.74063 22.9782V8.61077C5.74063 7.01439 7.04312 5.75664 8.58682 5.75664H26.2429L27.7866 0H8.58682C3.85924 0 0 3.87001 0 8.61077V22.9782C0 27.7189 3.85924 31.5889 8.58682 31.5889H19.3445L20.8882 25.8323H8.58682C6.99488 25.8323 5.74063 24.5745 5.74063 22.9782Z" fill="white" />
                                        <path d="M18.6637 13.8652C20.3436 13.8652 20.9969 14.1961 21.4635 14.6688L21.8835 15.1415L23.9833 13.2034L23.5633 12.7307C22.7234 11.8326 21.4168 11.4071 19.317 11.4071C15.6773 11.4071 12.9242 13.2034 12.1776 16.087C11.3843 19.0178 13.1575 20.7668 16.8439 20.7668C18.9904 20.7668 20.6236 20.2941 21.9301 19.3014L22.5368 18.8287L21.4635 16.8906L20.7636 17.4106C20.2036 17.836 19.3637 18.3087 17.4505 18.3087C14.2774 18.3087 14.7441 16.6069 14.884 16.0397C15.304 14.6216 16.5639 13.8652 18.6637 13.8652Z" fill="white" />
                                        <path d="M26.5253 20.7668L27.2513 17.9394H30.4275C34.1482 17.9394 35.2372 15.8432 35.5548 14.5758C36.0993 12.4796 34.9196 11.4071 32.061 11.4071H26.2985L23.9844 20.7668H26.5253ZM28.2496 13.9908H31.2896C33.1046 13.9908 33.0139 14.332 32.9231 14.6733C32.8324 14.9658 32.7416 15.4045 30.9267 15.4045H27.8866L28.2496 13.9908Z" fill="white" />
                                    </svg>
                                </span>
                                <span className={`logo-text`}>COVRPRICE</span>
                            </Space>
                        </a>
                    </Col>
                    <Col className={`pages`}>
                        <Space direction={`horizontal`}>
                            <Link to={Routes.PARTNER_PORTAL}>
                                <Button
                                    type={`link`}
                                    className={
                                        currentPage === Routes.PARTNER_PORTAL
                                            ? 'active'
                                            : ''
                                    }
                                >NR/FOC</Button>
                            </Link>
                            <Link to={Routes.PARTNER_PORTAL_PROFILE}>
                                <Button
                                    shape={`circle`}
                                    className={
                                        currentPage === `${Routes.PARTNER_PORTAL_PROFILE}`
                                            ? 'active'
                                            : ''
                                    }
                                >
                                    <UserIcon />
                                </Button>
                            </Link>
                        </Space>
                    </Col>
                </Row>
            </Contain>
        </div>
    );
};

export default MainNav;
